import { defineNuxtPlugin } from "#app";
import Cookies from "js-cookie";

export default defineNuxtPlugin((nuxtApp) => {
  const $cookies = {
    get: (name) => {
      return Cookies.get(name);
    },
    set: (name, value, options = {}) => {
      return Cookies.set(name, value, options);
    },
    remove: (name, options = {}) => {
      return Cookies.remove(name, options);
    },
  };

  // 提供 $cookies 给应用 - 使用 provide 方式（推荐）
  nuxtApp.provide("cookies", $cookies);
  nuxtApp.provide("$cookies", $cookies);

  // 注意：在 Nuxt 3 中，globalProperties 可能不可写
  // 建议使用 inject 方式或 useNuxtApp() 来访问
});
